import Logo from 'hcp/components/compliance/logo';
import SharedResponsibilityModel from 'hcp/components/compliance/shared-responsibility-model';
import Footer from 'hcp/components/compliance/footer';

<template>
  <main class="compliance g-grid-container font-hashicorp-sans">
    <Logo />

    <SharedResponsibilityModel />

    <Footer />
  </main>
</template>
